import React, { useEffect, useRef } from 'react';

const HTMLView = (props) => {
  const { data } = props;
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // 1. Alle im HTML vorhandenen Script-Tags finden
    const scripts = Array.from(container.querySelectorAll('script_external'));

    scripts.forEach((oldScript) => {
      // 2. Neues Script-Element erzeugen (diese WERDEN ausgeführt)
      const newScript = document.createElement('script');

      // 3. Alle Attribute übernehmen (src, type, async, defer, ...)
      Array.from(oldScript.attributes).forEach((attr) =>
        newScript.setAttribute(attr.name, attr.value),
      );

      // 4. Inline-Code übernehmen
      if (!oldScript.src) {
        newScript.appendChild(document.createTextNode(oldScript.textContent));
      }

      // 5. Altes, inaktives Script-Tag ersetzen
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }, [data?.html]); // Läuft neu, wenn der Block-Inhalt per Redux/Ajax aktualisiert wird

  return (
    <div
      ref={containerRef}
      className="html-block-view"
      dangerouslySetInnerHTML={{ __html: data?.html || '' }}
    />
  );
};

export default HTMLView;
